<template>
  <div class="dnd-character-gen">    
    <h1><span class="emoji-class--big">⚔</span> DND Character Generator <span class="emoji-class--big">⚔</span></h1>
    <img src="../assets/goblin.svg" class="goblin" />
    <div class="character-info">
      <p>{{ charObj.name }}</p>
      <p>{{ charObj.race }}</p>
      <p><span class="emoji-class">{{ charObj.classEmoji }}</span> {{charObj.class}} <span class="emoji-class">{{ charObj.classEmoji }}</span></p>
    </div>
    <div class="bio">
      <div v-if="!bio">
        <img src="../assets/d20.svg" class="d20"/>
        <p><span class="emoji-class">⚔</span> Generating a bio <span class="emoji-class">⚔</span></p>
      </div>
      <p v-if="bio">{{ bio }}</p>
    </div>
    
    <button v-on:click="regenerate" v-if="generating">
      <img src="../assets/d20.svg" class="d20"/>
      <img src="../assets/d20.svg" class="d20"/>
      <img src="../assets/d20.svg" class="d20"/>
    </button>
    <button v-on:click="regenerate" v-if="!generating">Generate Character</button>
    <span class="emoji-class--big-block">⚔</span>
  </div>
</template>

<script>
  
  import names from '../lib/generatedNames.js';
  import getAnOrA from '../lib/stringUtils.js';
  import ml5 from 'ml5';
  
  export default {
    name: 'DndCharacterGenerator',
    props: {
      showResults: Boolean
    },
    data() {
      return {
        character: "",
        charObj: "",
        bio: undefined,
        rnn: undefined,
        generating: true
      }
    },
    mounted() {
      this.rnn = ml5.charRNN('./assets/models/training_bios');

      let character = this.pickCharacter();
      this.character = character;
      
      let charObj = this.buildCharacter(character);
      this.charObj = charObj;
      this.generateContent(charObj);
    },
    methods: {
      regenerate() {
        this.bio = null;
        let character = this.pickCharacter();
        this.character = character;
        // console.log(character);
        
        let charObj = this.buildCharacter(character);
        this.charObj = charObj;
        this.generateContent(charObj);
      },
      pickCharacter() {
        return names[Math.floor(Math.random() * names.length)];
      },
      buildCharacter(character) {
        let charParts = character.split(',');
        
        let charObj = {
          name: charParts[0] != null ? charParts[0] : '',
          race: charParts[1] != null ? charParts[1] : '',
          class: charParts[2] != null ? charParts[2] : '',
          classEmoji: charParts[2] != null ? this.getClassEmoji(charParts[2]) : '',
        };
        return charObj;
      },
      modelLoaded() {
        console.log('Model Loaded!');
      },
      generateContent(charObj) {
        this.generating = true;
        let seedStr = `${charObj.name},${charObj.race},${charObj.class}`;
        let str = `${charObj.name} is ${getAnOrA(charObj.race)} ${charObj.race} ${charObj.class} from `;
      
        this.rnn.generate({ seed: seedStr, length: 200, temperature: 0.7 }, (err, results) => {
          // console.log(results);
          this.bio = str + results.sample;
          this.generating = false;
          return results;
        });
      },
      addClassEmoji(characterClass) {
        return `${this.getClassEmoji(characterClass)} ${characterClass} ${this.getClassEmoji(characterClass)}`;
      },
      getClassEmoji(characterClass) {
          switch(characterClass.toLowerCase()) {
            case 'sorcerer':
            case 'sorceress':
            case 'wizard':
              return '🧙‍♀️';
            case 'warrior':
            case 'barbarian':
              return '🛡⚔️';
            case 'fighter':
              return '👊🏽';
            case 'bard':
              return '🎭 🪕';
            case 'rogue':
              return '🤺';
            case 'paladin':
              return '🛡';
            case 'monk':
              return '🧘🏿‍♀️';
            case 'thief':
              return '🤏';
            case 'ranger':
              return '🥾';
            case 'druid':
              return '🌱';
            case 'shaman':
              return '🧙‍♀️';
            case 'cleric':
              return '⛪️';
            case 'warlock':
              return '🧙‍♂️';
            default: 
              return '';
          }
        }
    }
  }
</script>
<style scoped>

  .dnd-character-gen {
    text-align: center;
    font-family: 'Press Start 2P', cursive;
    font-size: 14px;
  }

  .goblin {
    width: 6em;
    height: 10em;
    padding-bottom: 0em;
  }

  .d20 {
    align-self: center;
    height: 50px;
    width: 50px;
    animation: roll 1.6s infinite;
    transform: rotate(30deg);
  }
  
  @keyframes roll {
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  button {
    font-family: 'Press Start 2P', cursive;
    font-size: 14px;
    padding: 0.5em;
    width: 22em;
    height: 5em;
    color: #565656;
    border: none;
    background: white;
    border: 1px solid #565656;
    cursor: pointer;
  }

  button:hover {
    color: black;
    border-bottom: 3px solid black;
    font-weight: bold;
  }

  h1 {
    color: black;
  }

  .character-info {
    border-bottom: 1px solid black;
    font-size: 16px;
  }

  .bio {
    padding: 1.5em;
    padding-bottom: 2em;
  }

  .emoji-class {
    font-size: 24px;
  }

  .emoji-class--big {
    font-size: 40px;
  }

  .emoji-class--big-block {
    font-size: 40px;
    display: block;
    padding-top: 0.5em;
  }

   @media screen and (max-width: 500px) {
    .emoji-class--big {
      display: block;
    }
    button {
      display: block;
    }
   }

  @media screen and (max-width: 700px) {
    .emoji-class--big {
      display: block;
    }
  }
</style>